module.exports = __webpack_public_path__ + "img/4.70c6a2e2.png";